import Vue from 'vue'
import Router from 'vue-router'

// App Route Components
import login from '@/components/login'
import signout from '@/components/signout'
import signUp from '@/components/Auth/signUp'
import confirmUser from '@/components/Auth/confirmUser'
import challengeBase from '@/components/Auth/challengeBase'
import createNewPassword from '@/components/Auth/createNewPassword'
import forgotPassword from '@/components/Auth/forgotPassword'
import dashboard from '@/components/dashboard'
import profile from '@/components/profile'
import search from '../components/search'
import error404 from '../components/errors/404'
import accessForbidden from '../components/errors/accessForbidden'

// vuex
import { store } from '../store/index'

Vue.use(Router)

export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: login,
      meta: {
        requiresAuth: false,
        menuItem: false,
        title: 'Login | iPro\u00AE Systems, LLC',
        app: 'accounts'
      }
    },
    {
      path: '/signout',
      name: 'signout',
      component: signout,
      meta: {
        requiresAuth: false,
        menuItem: false,
        title: 'Sign Out | iPro\u00AE Systems, LLC',
        app: 'accounts'
      }
    },
    {
      path: '/forgotpassword',
      name: 'forgotPassword',
      component: forgotPassword,
      meta: {
        requiresAuth: false,
        menuItem: false,
        title: 'Forgot Password | iPro\u00AE Systems, LLC',
        app: 'accounts'
      }
    },
    {
      path: '/signup',
      name: 'signup',
      component: signUp,
      meta: {
        requiresAuth: true, // set to true to prevent user sign ups for inital launch - once ready for user sign ups set to false
        menuItem: false,
        title: 'Sign Up | iPro\u00AE Systems, LLC',
        app: 'accounts'
      }
    },
    {
      path: '/confirm',
      name: 'confirm',
      component: confirmUser,
      meta: {
        requiresAuth: false,
        menuItem: false,
        title: 'Confirm Sign Up | iPro\u00AE Systems, LLC',
        app: 'accounts'
      }
    },
    {
      path: '/challenge/',
      name: 'challenge',
      component: challengeBase,
      meta: {
        requiresAuth: true,
        menuItem: false,
        title: 'Confirm Sign Up | iPro\u00AE Systems, LLC',
        app: 'accounts'
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: dashboard,
      meta: {
        requiresAuth: true,
        menuItem: true,
        menuName: 'Home',
        title: 'Account Management | iPro\u00AE Systems, LLC',
        app: 'accounts'
      }
    },
    {
      path: '/profile',
      name: 'profile',
      component: profile,
      meta: {
        requiresAuth: true,
        menuItem: true,
        menuName: 'Profile',
        title: 'Profile | iPro\u00AE Systems, LLC - Account Management',
        app: 'accounts'
      }
    },
    {
      path: '/change-password',
      name: 'changePassword',
      component: createNewPassword,
      meta: {
        requiresAuth: true,
        menuItem: false,
        title: 'Change Password | iPro\u00AE Systems, LLC - Account Management',
        app: 'accounts'
      }
    },
    {
      path: '/search',
      name: 'search',
      component: search,
      meta: {
        requiresAuth: true,
        menuItem: false,
        title: 'Search | iPro\u00AE Systems, LLC - Account Management',
        app: 'accounts'
      }
    },
    {
      path: '/access-forbidden',
      name: 'accessForbidden',
      component: accessForbidden,
      meta: {
        requiresAuth: true,
        menuItem: false,
        title: 'Access Forbidden | iPro\u00AE Systems, LLC - Account Management',
        app: 'accounts'
      }
    },
    {
      path: '*',
      name: '404',
      component: error404,
      meta: {
        requiresAuth: true,
        menuItem: false,
        title: '404 - Page Not Found | iPro\u00AE Systems, LLC - Account Management',
        app: 'accounts'
      }
    }
  ]
})

router.beforeResolve(async (to, from, next) => {
  if (to.hasOwnProperty('meta')) {
    // Use the route's "meta.title" value to assign the page's title
    if (to.meta.hasOwnProperty('title') && to.meta.title) document.title = to.meta.title
    let user = await store.get('auth/valid')
    // For routes requiring authentication ( has "meta.auth" property )
    if (!to.meta.hasOwnProperty('requiresAuth') || to.meta.requiresAuth === true) {
      if (!user) {
        return next('/')
      }
      return next()
    } else if (to.path === '/' && user) {
      return next('/dashboard')
    }
    return next()
  }
  return next()
})



// WEBPACK FOOTER //
// ./src/router/index.js